/**
 * What an "Ask Iris" button shows (CU-869fkdhjv phase 3, UX § c), from the same Iris state the launcher reads
 * (`Layout/irisState.js`, C1: one source).
 *
 * Not painted for a user without Iris, with nothing to explain (no data, loading, N/A) or over the tour's demo
 * rows (C6). Disabled with its reason: not available > starting > answering. Pure (TL R4).
 */
export const ASK_REASONS = {
	offline: 'Iris is not available right now',
	starting: 'Iris is starting…',
	busy: 'Iris is answering',
}

export function askButtonState({ isIrisUser, iris, hasData, demo = false }) {
	if (!isIrisUser || !hasData || demo) return { mode: 'hidden' }
	if (iris?.offline) return { mode: 'disabled', reason: ASK_REASONS.offline }
	if (!iris?.ready) return { mode: 'disabled', reason: ASK_REASONS.starting }
	if (iris?.busy) return { mode: 'disabled', reason: ASK_REASONS.busy }
	return { mode: 'idle' }
}

/**
 * Identity of the button (CU-869fkdhjv, UX § Button identity, direction B "Bocadillo", Curro 2026-10-28):
 * everything reduces to "Ask Iris" — every labelled form says only that, and what it is about goes in the tooltip.
 */
export const ASK_TEXT = 'Ask Iris'

const DEFAULT_TOOLTIP = { block: 'Ask Iris about this price', screen: 'Ask Iris about this screen' }

/** The tooltip (and accessible name) of an idle button: the caller's, else the form's default, else "Ask Iris". */
export function askTooltip(variant, tooltip) {
	return tooltip || DEFAULT_TOOLTIP[variant] || ASK_TEXT
}

/**
 * The look a state takes (UX shared state grammar): `idle`; `wait` while Iris starts or answers — all grey, the mark
 * breathes; `off` when Iris is not available — grey mark, dashed edge.
 */
export function askTone(look) {
	if (look?.mode !== 'disabled') return 'idle'
	return look.reason === ASK_REASONS.offline ? 'off' : 'wait'
}
